<template>
    <div class="coldContainer" :class="{'coldContainerDark' : isDark}">
        <TitleBar title="指数波动" :txt="txt" :type="type"></TitleBar>
        <div class="coldBox">
            <div class="coldCard left" @click="goModelList">
                <p class="margin">{{disLeft.home_team}}<span v-if="disData.is_pay === 0">{{disLeft.home_score}}</span></p>
                <p class="margin">{{disLeft.guest_team}}<span v-if="disData.is_pay === 0">{{disLeft.guest_score}}</span></p>
                <div class="btm">
                    <span class="league" :style="{color: disLeft.sclass_color}">{{disLeft.sclass_name}}</span>
                    <span class="time">{{matchTimeLeft}}</span>
                </div>
                <div class="result">
                    <p v-if="disData.is_pay === 0" class="odds">
                        <img v-if="disLeft.ret === 'home'" src="../../assets/img/datamodel/homewin.png" />
                        <img v-if="disLeft.ret === 'guest'" src="../../assets/img/datamodel/guestwin.png" />
                        <img v-if="disLeft.ret === 'stand'" src="../../assets/img/datamodel/stand.png" />
                    </p>
                    <p v-else class="val">{{disLeft.count}}</p>
                    <p v-if="disData.is_pay === 0">赛果命中</p>
                    <p v-else>波动相似场次</p>
                </div>
            </div>
            <div class="coldCard" @click="goModelList">
                <p class="margin">{{disRight.home_team}}<span v-if="disData.is_pay === 0">{{disRight.home_score}}</span></p>
                <p class="margin">{{disRight.guest_team}}<span v-if="disData.is_pay === 0">{{disRight.guest_score}}</span></p>
                <div class="btm">
                    <span class="league" :style="{color: disRight.sclass_color}">{{disRight.sclass_name}}</span>
                    <span class="time">{{matchTimeRight}}</span>
                </div>
                <div class="result">
                    <p v-if="disData.is_pay === 0" class="odds">
                        <img v-if="disRight.ret === 'home'" src="../../assets/img/datamodel/homewin.png" />
                        <img v-if="disRight.ret === 'guest'" src="../../assets/img/datamodel/guestwin.png" />
                        <img v-if="disRight.ret === 'stand'" src="../../assets/img/datamodel/stand.png" />
                    </p>
                    <p v-else class="val">{{disRight.count}}</p>
                    <p v-if="disData.is_pay === 0">赛果命中</p>
                    <p v-else>波动相似场次</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleBar from './common/titleBar.vue'
export default {
    name: 'oddsWaveCorpus',
    props: ['disData'],
    components: {
        TitleBar
    },
    watch: {
        data: {
            handler () {
                this.renderDisList();
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    data () {
        return {
            type: "17",
            txt: '',
            disLeft: {},
            disRight: {},
            matchTimeLeft: '',
            matchTimeRight: ''
        }
    },
    methods: {
        renderDisList () {
            if (this.disData) {
                this.disLeft = this.disData.list[0];
                this.disRight = this.disData.list[1];
                this.matchTimeLeft = this.disData.list[0].match_time.substring(5, 16).replace('-', '月');
                this.matchTimeRight = this.disData.list[1].match_time.substring(5, 16).replace('-', '月');
                if (this.disData.type_num * 1 > 0) {
                    this.txt = '（近7日命中' + this.disData.type_num + '场）';
                } else {
                    this.txt = '';
                }
            }
        },
        goModelList () {
            this.$emit('goDetail', this.type);
        }
    }
}
</script>
